import { render, staticRenderFns } from "./ProductRequirementValues.vue?vue&type=template&id=65101a7c&"
import script from "./ProductRequirementValues.vue?vue&type=script&lang=js&"
export * from "./ProductRequirementValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports